/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpCreateServerHeader } from "../funcs/remoteMcpCreateServerHeader.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteMcpServerHeader } from "../models/components/remotemcpserverheader.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateRemoteMcpServerHeaderRequest,
  CreateRemoteMcpServerHeaderSecurity,
} from "../models/operations/createremotemcpserverheader.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateRemoteMcpServerHeaderMutationVariables = {
  request: CreateRemoteMcpServerHeaderRequest;
  security?: CreateRemoteMcpServerHeaderSecurity | undefined;
  options?: RequestOptions;
};

export type CreateRemoteMcpServerHeaderMutationData = RemoteMcpServerHeader;

export type CreateRemoteMcpServerHeaderMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createServerHeader remoteMcp
 *
 * @remarks
 * Create a header on a remote MCP server
 */
export function useCreateRemoteMcpServerHeaderMutation(
  options?: MutationHookOptions<
    CreateRemoteMcpServerHeaderMutationData,
    CreateRemoteMcpServerHeaderMutationError,
    CreateRemoteMcpServerHeaderMutationVariables
  >,
): UseMutationResult<
  CreateRemoteMcpServerHeaderMutationData,
  CreateRemoteMcpServerHeaderMutationError,
  CreateRemoteMcpServerHeaderMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateRemoteMcpServerHeaderMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateRemoteMcpServerHeader(): MutationKey {
  return ["@gram/client", "remoteMcp", "createServerHeader"];
}

export function buildCreateRemoteMcpServerHeaderMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateRemoteMcpServerHeaderMutationVariables,
  ) => Promise<CreateRemoteMcpServerHeaderMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateRemoteMcpServerHeader(),
    mutationFn: function createRemoteMcpServerHeaderMutationFn({
      request,
      security,
      options,
    }): Promise<CreateRemoteMcpServerHeaderMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(remoteMcpCreateServerHeader(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
